import { useRouteMatch } from 'react-router-dom';

const useConnect = () => {
  const { path } = useRouteMatch();

  return {
    path,
  };
};

export default useConnect;
